import React from 'react'
import PropTypes from 'prop-types'
import convert from 'htmr'

const transform = {
  // eslint-disable-next-line react/prop-types
  img: function Image({ src, ...rest }) {
    return (
      <img
        {...rest}
        // eslint-disable-next-line react/prop-types
        src={src.replace(
          'https://lifesumcomprod.wpengine.com/',
          'https://lifesum-wordpress-offload.s3.eu-north-1.amazonaws.com/',
        )}
      />
    )
  },
}

export default function TextBlock({ text }) {
  return <div className="s-text">{convert(text, { transform })}</div>
}

TextBlock.propTypes = {
  text: PropTypes.string,
}
